// Fetch All Promo Codes
export const FETCH_ALL_PROMOCODE_REQUEST = "FETCH_ALL_PROMOCODE_REQUEST";
export const FETCH_ALL_PROMOCODE_SUCCESS = "FETCH_ALL_PROMOCODE_SUCCESS";
export const FETCH_ALL_PROMOCODE_FAILURE = "FETCH_ALL_PROMOCODE_FAILURE";
export const RESET_FETCH_ALL_PROMOCODE = "RESET_FETCH_ALL_PROMOCODE";

// Create Promo Codes
export const CREATE_PROMOCODE_REQUEST = "CREATE_PROMOCODE_REQUEST";
export const CREATE_PROMOCODE_SUCCESS = "CREATE_PROMOCODE_SUCCESS";
export const CREATE_PROMOCODE_FAILURE = "CREATE_PROMOCODE_FAILURE";
export const RESET_CREATE_PROMOCODE = "RESET_CREATE_PROMOCODE";


// View Promo Code
export const VIEW_PROMOCODE_REQUEST = "VIEW_PROMOCODE_REQUEST";
export const VIEW_PROMOCODE_SUCCESS = "VIEW_PROMOCODE_SUCCESS";
export const VIEW_PROMOCODE_FAILURE = "VIEW_PROMOCODE_FAILURE";
export const RESET_VIEW_PROMOCODE = "RESET_VIEW_PROMOCODE";

// Update Promo Code
export const UPDATE_PROMOCODE_REQUEST = "UPDATE_PROMOCODE_REQUEST";
export const UPDATE_PROMOCODE_SUCCESS = "UPDATE_PROMOCODE_SUCCESS";
export const UPDATE_PROMOCODE_FAILURE = "UPDATE_PROMOCODE_FAILURE";
export const RESET_UPDATE_PROMOCODE = "RESET_UPDATE_PROMOCODE";

// Delete Promo Code
export const DELETE_PROMOCODE_REQUEST = "DELETE_PROMOCODE_REQUEST";
export const DELETE_PROMOCODE_SUCCESS = "DELETE_PROMOCODE_SUCCESS";
export const DELETE_PROMOCODE_FAILURE = "DELETE_PROMOCODE_FAILURE";
export const RESET_DELETE_PROMOCODE = "RESET_DELETE_PROMOCODE";

//Approval Status
export const APPROVAL_PROMOCODE_REQUEST = "APPROVAL_PROMOCODE_REQUEST";
export const APPROVAL_PROMOCODE_SUCCESS = "APPROVAL_PROMOCODE_SUCCESS";
export const APPROVAL_PROMOCODE_FAILURE = "APPROVAL_PROMOCODE_FAILURE";
export const RESET_APPROVAL_PROMOCODE = "RESET_APPROVAL_PROMOCODE";

//Promo Code validation
export const VALIDATE_PROMOCODE_REQUEST = "VALIDATE_PROMOCODE_REQUEST";
export const VALIDATE_PROMOCODE_SUCCESS = "VALIDATE_PROMOCODE_SUCCESS";
export const VALIDATE_PROMOCODE_FAILURE = "VALIDATE_PROMOCODE_FAILURE";
export const RESET_VALIDATE_PROMOCODE = "RESET_VALIDATE_PROMOCODE";
